"use client";

import dynamic from "next/dynamic";
import { SocketProvider } from "../context/SocketContext";

/* Disable SSR for the entire page — this is a client-side game app.
   Prevents hydration mismatches caused by browser extensions injecting
   attributes (e.g. Bitdefender's bis_skin_checked) before React hydrates. */
const HomeClient = dynamic(() => import("./HomeClient"), { ssr: false });

export default function Page() {
  return (
    <SocketProvider>
      <HomeClient />
    </SocketProvider>
  );
}
